export default "__VITE_ASSET__32feb95d__"